import { t } from '@core/i18n';

export const getInclusiveRadioOptions = () => [
  {
    id: 'exclusive',
    label: t('exclusive'),
    tooltip: t('rent_exclusive_of_business_rates_and_charges'),
  },
  {
    id: 'inclusive',
    label: t('inclusive'),
    tooltip: t('rent_inclusive_of_business_rates_and_charges'),
  },
  {
    id: 'na',
    label: t('na'),
    tooltip: t('not_applicable'),
  },
];
